export default "__VITE_ASSET__CVR8ok1I__"